
import InitRecordBuilder from "slotworks/integration/revolver/builders/records/auth-record-builder";
import CampaignsRecordBuilder from 'slotworks/integration/revolver/builders/records/campaigns-record-builder';
import BalanceRecordBuilder from "slotworks/integration/revolver/builders/records/balance-record-builder";
import MessageBoxRecordBuilder from "slotworks/integration/revolver/builders/records/message-record-builder";
import ErrorRecordBuilder from "slotworks/integration/revolver/builders/records/error-record-builder";
import SpinRecordBuilder from "slotworks/integration/revolver/builders/records/spin-record-builder";
import InitRequestBuilder from "slotworks/integration/revolver/builders/requests/auth-request-builder";
import FreespinRequestBuilder from "slotworks/integration/revolver/builders/requests/freespin-request-builder";
import SpinRequestBuilder from "slotworks/integration/revolver/builders/requests/spin-request-builder";
import BonusResultBuilder from "slotworks/integration/revolver/builders/results/bonus-result-builder";
import LineResultBuilder from "slotworks/integration/revolver/builders/results/line-result-builder";
import ScatterResultBuilder from "slotworks/integration/revolver/builders/results/scatter-result-builder";
import RevolverModel from "slotworks/integration/revolver/model/revolver-model";
import RecoverSpin from "slotworks/integration/revolver/states/recover-spin";
import RevolverJumpToFreespins from "slotworks/integration/revolver/states/revolver-jump-to-freespins";
import RevolverLateFreespinCheck from "slotworks/integration/revolver/states/revolver-late-freespin-check";
import RevolverOpen from "slotworks/integration/revolver/states/revolver-open";
import BuilderManager from "slotworks/server/builders/builder-manager";
import CommsManager from "slotworks/server/comms-manager";
import HTTPConnector from "slotworks/server/connectors/http-connector";
import StateMachine from "slotworks/state-machine/state-machine";
import StateRegister from "slotworks/state-machine/state-register";
import RevolverBigWins from "./states/revolver-big-wins";
import RevolverExitFreespins from "./states/revolver-exit-freespins";

const commsConfig = require("comms-config.json");

declare const require: any;
declare const __ENVIRONMENT__: string;

export default class RevolverBuilders {

    public static init() {

        HTTPConnector.withCredentials = true;
        CommsManager.connector = HTTPConnector;
        RevolverModel.init(commsConfig);

        BuilderManager.addRequestBuilder(InitRequestBuilder);
        BuilderManager.addRequestBuilder(SpinRequestBuilder);
        BuilderManager.addRequestBuilder(FreespinRequestBuilder);

        BuilderManager.addRecordBuilder(InitRecordBuilder);
        BuilderManager.addRecordBuilder(CampaignsRecordBuilder);
        BuilderManager.addRecordBuilder(SpinRecordBuilder);
        BuilderManager.addRecordBuilder(ErrorRecordBuilder);
        BuilderManager.addRecordBuilder(BalanceRecordBuilder);
        BuilderManager.addRecordBuilder(MessageBoxRecordBuilder);

        BuilderManager.addResultBuilder(LineResultBuilder);
        BuilderManager.addResultBuilder(ScatterResultBuilder);
        BuilderManager.addResultBuilder(BonusResultBuilder);

        StateRegister.add("revolver-open", new RevolverOpen(StateMachine));

        StateRegister.add("revolver-recover-spin", new RecoverSpin(StateMachine));
        StateRegister.add("revolver-jump-to-freespins", new RevolverJumpToFreespins(StateMachine));

        StateRegister.add("revolver-exit-freespins", new RevolverExitFreespins(StateMachine));

        StateRegister.add("revolver-big-wins", new RevolverBigWins(StateMachine));

        StateRegister.add("revolver-late-freespin-check", new RevolverLateFreespinCheck());
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/revolver-builders.ts